import * as React from "react";
import SideBarLink from "./SidebarLink";
import * as firebase from "../../firebase";
import "./styles.scss";
import { URL_PATHS } from "../../routes";
import { useHistory } from "react-router-dom";
import { oneLink } from "../../shared/oneLink";

interface SideBarProps {
    isSidebarOpen: boolean;
}

const SideBar = (props: SideBarProps) => {
    const history = useHistory();
    async function onLogout() {
        await firebase.logout();
        history.push(URL_PATHS.logout());
    }
    const onPaymentInfo = (): void => {
        history.push(URL_PATHS.paymentInfo());
    };
    const onMyPage = (): void => {
        history.push(URL_PATHS.myPage());
    };
    const onContractPaidMember = (): void => {
        history.push(URL_PATHS.contractPaidMember());
    };
    return (
        <div
            className="sidebar"
            style={{ right: props.isSidebarOpen ? 0 : "-250px" }}
        >
            <div className="burger">
                <SideBarLink href={oneLink()} primary={true}>
                    アプリを開く
                </SideBarLink>
                <SideBarLink onClickLink={onMyPage}>マイページ</SideBarLink>
                <SideBarLink onClickLink={onPaymentInfo}>
                    決済について
                </SideBarLink>
                <SideBarLink href="https://tameny.jp/privacy/">
                    プライバシーポリシー
                </SideBarLink>
                <SideBarLink href="https://p-a.app/pages/terms/">
                    利用規約
                </SideBarLink>
                <SideBarLink href="https://support.p-a.app/hc/ja">
                    ヘルプ
                </SideBarLink>
                <SideBarLink onClickLink={onContractPaidMember}>
                    契約確認・変更
                </SideBarLink>
                <SideBarLink onClickLink={onLogout}>ログアウト</SideBarLink>
            </div>
        </div>
    );
};

export default SideBar;
